<template>
  <div class="notification-settings">
    <h4 class="mb-1">
      إعدادات الإشعارات
    </h4>
    <p class="text-muted mb-2">
      تحكم في إشعارات المتصفح والصوت داخل التطبيق.
    </p>

    <b-card class="mb-2">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h5 class="mb-25">
            إشعارات المتصفح (Push)
          </h5>
          <small class="text-muted">
            تظهر حتى عندما يكون التطبيق في الخلفية أو مغلقًا.
          </small>
        </div>
        <b-form-checkbox
          v-model="pushEnabled"
          switch
          size="lg"
          :disabled="saving"
          @change="onPushToggle"
        />
      </div>

      <b-alert
        v-if="pushPermissionDenied"
        show
        variant="warning"
        class="mt-1 mb-0"
      >
        تم رفض إذن الإشعارات من المتصفح. فعّل الإشعارات من إعدادات المتصفح ثم أعد المحاولة.
      </b-alert>

      <b-alert
        v-else-if="!vapidConfigured"
        show
        variant="info"
        class="mt-1 mb-0"
      >
        مفتاح VAPID غير مُعرَّف. أضف <code>VUE_APP_FIREBASE_VAPID_KEY</code> في ملف البيئة لتفعيل الإشعارات.
      </b-alert>
    </b-card>

    <b-card>
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h5 class="mb-25">
            صوت الإشعارات
          </h5>
          <small class="text-muted">
            تشغيل صوت عند وصول إشعار جديد داخل التطبيق.
          </small>
        </div>
        <b-form-checkbox
          v-model="soundEnabled"
          switch
          size="lg"
          :disabled="saving"
          @change="onSoundToggle"
        />
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormCheckbox,
  BAlert,
} from 'bootstrap-vue'
import {
  getNotificationPreferences,
  setPushNotificationsEnabled,
  setNotificationSoundEnabled,
} from '@/utils/notificationPreferences'
import {
  enablePushNotifications,
  disablePushNotifications,
} from '@/firebase/messaging'
import { firebaseVapidKey } from '@/firebase/config'

export default {
  name: 'NotificationSettings',
  components: {
    BCard,
    BFormCheckbox,
    BAlert,
  },
  data() {
    const preferences = getNotificationPreferences()

    return {
      pushEnabled: preferences.pushEnabled,
      soundEnabled: preferences.soundEnabled,
      saving: false,
      pushPermissionDenied: false,
    }
  },
  computed: {
    vapidConfigured() {
      return !!firebaseVapidKey
    },
  },
  methods: {
    async onPushToggle(enabled) {
      this.saving = true
      this.pushPermissionDenied = false

      try {
        if (enabled) {
          const { token, error, code } = await enablePushNotifications()

          if (!token) {
            this.pushEnabled = false
            setPushNotificationsEnabled(false)

            if (code === 'permission_denied' || Notification.permission === 'denied') {
              this.pushPermissionDenied = true
              this.$toast.warning('تم رفض إذن الإشعارات من المتصفح.')
            } else if (code === 'missing_vapid_key') {
              this.$toast.warning('مفتاح VAPID غير مُعرَّف في ملف البيئة.')
            } else if (code === 'token_empty' || code === 'get_token_failed') {
              console.error('FCM token error:', error, code)
              this.$toast.warning('تعذر الحصول على رمز FCM. تأكد من مفتاح VAPID في Firebase Console ثم أعد تشغيل السيرفر.')
            } else {
              console.error('FCM enable failed:', error, code)
              this.$toast.warning(error || 'تعذر تفعيل إشعارات المتصفح.')
            }
            return
          }

          setPushNotificationsEnabled(true)
          this.$toast.success('تم تفعيل إشعارات المتصفح')
        } else {
          await disablePushNotifications()
          setPushNotificationsEnabled(false)
          this.$toast.info('تم إيقاف إشعارات المتصفح')
        }
      } catch (error) {
        console.error('Push notification toggle failed:', error)
        this.pushEnabled = !enabled
        this.$toast.error('حدث خطأ أثناء تحديث إعدادات الإشعارات')
      } finally {
        this.saving = false
      }
    },

    onSoundToggle(enabled) {
      setNotificationSoundEnabled(enabled)
      this.$toast.info(enabled ? 'تم تفعيل صوت الإشعارات' : 'تم إيقاف صوت الإشعارات')
    },
  },
}
</script>

<style scoped>
.notification-settings h5 {
  font-size: 1rem;
}
</style>
